// Synthetic data for Alwasl Recovery OS prototype.
// All names, IDs, phones, amounts are fictitious.

export const PERSONAS = [
  { id: 'manager', name: 'Collection Manager', short: 'Manager', user: 'Eisa A. Bin Mahfouz', initials: 'EM', email: 'manager@alwasl.demo' },
  { id: 'supervisor', name: 'Collection Supervisor', short: 'Supervisor', user: 'Ziad Bouhaimed', initials: 'ZB', email: 'supervisor@alwasl.demo' },
  { id: 'agent', name: 'Collection Agent', short: 'Agent', user: 'Fares Sayer', initials: 'FS', email: 'agent@alwasl.demo' },
  { id: 'legal', name: 'Legal Officer', short: 'Legal', user: 'Abdullah M. Bin Mahfouz', initials: 'AM', email: 'legal@alwasl.demo' },
  { id: 'compliance', name: 'Compliance / QA Officer', short: 'Compliance', user: 'Omar Al-Sayari', initials: 'OS', email: 'compliance@alwasl.demo' },
  { id: 'admin', name: 'Admin / IT Manager', short: 'Admin', user: 'Mohammed Bin Marta', initials: 'MM', email: 'admin@alwasl.demo' },
];

export const CLIENTS = [
  { id: 'CLI-001', name: 'Saudi Retail Bank — Synthetic', sector: 'Retail Banking', priority: 'A', portfolio: 'PRT-2026-014' },
  { id: 'CLI-002', name: 'Najm Auto Finance — Synthetic', sector: 'Auto Finance', priority: 'A', portfolio: 'PRT-2026-015' },
  { id: 'CLI-003', name: 'Tamam BNPL — Synthetic', sector: 'BNPL', priority: 'B', portfolio: 'PRT-2026-016' },
  { id: 'CLI-004', name: 'Mawared Telecom — Synthetic', sector: 'Telecom', priority: 'B', portfolio: 'PRT-2026-017' },
  { id: 'CLI-005', name: 'Bidaya Home Finance — Synthetic', sector: 'Mortgage', priority: 'A', portfolio: 'PRT-2026-018' },
];

export const PORTFOLIOS = [
  { id: 'PRT-2026-014', client: 'CLI-001', clientName: 'Saudi Retail Bank', accounts: 1284, value: 14820500, validated: 1242, duplicates: 18, missingPhone: 24, status: 'Ready to Assign', healthScore: 92, ageingBuckets: { '0-30': 12, '31-60': 28, '61-90': 30, '91-180': 20, '180+': 10 } },
  { id: 'PRT-2026-015', client: 'CLI-002', clientName: 'Najm Auto Finance', accounts: 642, value: 27305000, validated: 618, duplicates: 10, missingPhone: 14, status: 'Assigned', healthScore: 88, ageingBuckets: { '0-30': 8, '31-60': 22, '61-90': 34, '91-180': 26, '180+': 10 } },
  { id: 'PRT-2026-016', client: 'CLI-003', clientName: 'Tamam BNPL', accounts: 3120, value: 4980000, validated: 2998, duplicates: 56, missingPhone: 66, status: 'Validating', healthScore: 74, ageingBuckets: { '0-30': 40, '31-60': 30, '61-90': 18, '91-180': 8, '180+': 4 } },
  { id: 'PRT-2026-017', client: 'CLI-004', clientName: 'Mawared Telecom', accounts: 884, value: 1235800, validated: 882, duplicates: 2, missingPhone: 0, status: 'Assigned', healthScore: 95, ageingBuckets: { '0-30': 22, '31-60': 36, '61-90': 24, '91-180': 12, '180+': 6 } },
  { id: 'PRT-2026-018', client: 'CLI-005', clientName: 'Bidaya Home Finance', accounts: 218, value: 38420000, validated: 214, duplicates: 0, missingPhone: 4, status: 'Pre-Legal Review', healthScore: 91, ageingBuckets: { '0-30': 6, '31-60': 14, '61-90': 22, '91-180': 30, '180+': 28 } },
];

export const AGENTS = [
  { id: 'AGT-011', name: 'Fares Sayer', branch: 'Riyadh', lang: ['AR', 'EN'], skill: 'Senior • Retail', activeCases: 38, capacity: 45, todayCalls: 24, ptpToday: 6, recovery: 38.4 },
  { id: 'AGT-012', name: 'Sara Al-Qahtani', branch: 'Jeddah', lang: ['AR'], skill: 'Auto Finance', activeCases: 42, capacity: 45, todayCalls: 31, ptpToday: 8, recovery: 41.1 },
  { id: 'AGT-013', name: 'Mohammed Al-Otaibi', branch: 'Dammam', lang: ['AR', 'EN'], skill: 'Pre-Legal', activeCases: 28, capacity: 40, todayCalls: 18, ptpToday: 4, recovery: 34.8 },
  { id: 'AGT-014', name: 'Layla Bin Ali', branch: 'Riyadh', lang: ['AR', 'EN'], skill: 'BNPL • Junior', activeCases: 35, capacity: 40, todayCalls: 27, ptpToday: 5, recovery: 29.6 },
  { id: 'AGT-015', name: 'Khalid Al-Harbi', branch: 'Jeddah', lang: ['AR'], skill: 'Mortgage', activeCases: 19, capacity: 35, todayCalls: 14, ptpToday: 3, recovery: 44.2 },
  { id: 'AGT-016', name: 'Noura Al-Dosari', branch: 'Riyadh', lang: ['AR', 'EN'], skill: 'Telecom', activeCases: 46, capacity: 50, todayCalls: 35, ptpToday: 9, recovery: 36.7 },
];

export const STATUS_OPTIONS = [
  'New Import', 'Validated', 'Assigned', 'Contact Scheduled', 'Contacted',
  'Promise to Pay', 'Payment Plan Active', 'Paid / Closed', 'Broken Promise',
  'Dispute Hold', 'Complaint Hold', 'Legal Candidate', 'Legal In Progress', 'Uncollectible',
];

const names = [
  { n: 'Fahad A.', g: 'M' }, { n: 'Mona K.', g: 'F' }, { n: 'Ahmed B.', g: 'M' }, { n: 'Reem S.', g: 'F' },
  { n: 'Khalid Y.', g: 'M' }, { n: 'Sara F.', g: 'F' }, { n: 'Yousef M.', g: 'M' }, { n: 'Norah H.', g: 'F' },
  { n: 'Bandar A.', g: 'M' }, { n: 'Hessa O.', g: 'F' }, { n: 'Tariq N.', g: 'M' }, { n: 'Latifa S.', g: 'F' },
  { n: 'Saud R.', g: 'M' }, { n: 'Ghada T.', g: 'F' }, { n: 'Omar Z.', g: 'M' }, { n: 'Aisha L.', g: 'F' },
  { n: 'Faisal D.', g: 'M' }, { n: 'Hind W.', g: 'F' }, { n: 'Majed Q.', g: 'M' }, { n: 'Lama K.', g: 'F' },
  { n: 'Nasser J.', g: 'M' }, { n: 'Maha B.', g: 'F' }, { n: 'Talal H.', g: 'M' }, { n: 'Rana E.', g: 'F' },
  { n: 'Sultan V.', g: 'M' }, { n: 'Mai P.', g: 'F' }, { n: 'Hussain U.', g: 'M' }, { n: 'Dana C.', g: 'F' },
  { n: 'Walid X.', g: 'M' }, { n: 'Rawan Z.', g: 'F' },
];
const nationalities = ['SA', 'SA', 'SA', 'SA', 'EG', 'EG', 'JO', 'AE', 'LB', 'SY'];
export const NATION_LABEL = { SA: 'Saudi', EG: 'Egyptian', JO: 'Jordanian', AE: 'Emirati', LB: 'Lebanese', SY: 'Syrian' };
export const NATION_FLAG = { SA: '🇸🇦', EG: '🇪🇬', JO: '🇯🇴', AE: '🇦🇪', LB: '🇱🇧', SY: '🇸🇾' };
const products = ['Personal Finance', 'Auto Loan', 'BNPL Plan', 'Mortgage', 'Postpaid Telecom', 'Credit Card'];
const statuses = ['Assigned', 'Contact Scheduled', 'Contacted', 'Promise to Pay', 'Payment Plan Active', 'Broken Promise'];
const segments = ['Self-Service', 'Agent Negotiation', 'Pre-Legal', 'Legal', 'Skip Trace'];
const regions = ['Riyadh', 'Jeddah', 'Dammam', 'Madinah', 'Khobar', 'Mecca'];

const seedRand = (i) => {
  // deterministic pseudo random for stable demo data
  const x = Math.sin(i * 9301 + 49297) * 233280;
  return x - Math.floor(x);
};

export const DEBTORS = Array.from({ length: 30 }).map((_, i) => {
  const r = (off) => seedRand(i + off);
  const amount = Math.round(800 + r(1) * 92000);
  const days = Math.round(8 + r(2) * 240);
  const propensity = Math.round(20 + r(3) * 78);
  const contactability = Math.round(30 + r(4) * 70);
  const legalRisk = Math.round(5 + r(5) * 90);
  const priority = Math.round(
    Math.min(98, (amount / 1000) * 0.25 + days * 0.18 + propensity * 0.15 + contactability * 0.12 + (100 - legalRisk) * 0.1 + r(6) * 15)
  );
  const client = CLIENTS[i % CLIENTS.length];
  const agent = AGENTS[i % AGENTS.length];
  // Status: random workflow state for most, but pinned for the compliance demo cases.
  let status = statuses[Math.floor(r(7) * statuses.length)];
  if (i === 21) status = 'Dispute Hold';
  if (i === 26) status = 'Legal Candidate';
  const segment = segments[Math.floor(r(8) * segments.length)];
  const nameObj = names[i % names.length];
  const nationality = nationalities[Math.floor(r(18) * nationalities.length)];
  // Compliance-relevant counters & holds (synthetic).  A few debtors are
  // deliberately at the SAMA cap / on hold / opt-out so the rules engine
  // demonstrates each enforcement path visibly without flagging every debtor.
  const callAttempts = i === 7 ? 10 : i === 12 ? 9 : Math.floor(r(19) * 5);
  const waAttempts   = i === 19 ? 20 : Math.floor(r(20) * 6);
  const smsAttempts  = Math.floor(r(21) * 10);
  const disputeHold  = i === 21;
  const hardshipHold = i === 0;
  const legalHold    = i === 26;
  const optOutWa     = i === 19; // Same debtor at WhatsApp cap also opted out (post-cap behaviour)
  const contactWindowBlocked = i === 14; // Exactly one debtor — preferred window 17:00–20:00 and we're outside it.
  return {
    caseId: `CASE-${10400 + i}`,
    debtorId: `DBT-${88200 + i}`,
    name: nameObj.n,
    gender: nameObj.g,
    nationality,
    nationalityLabel: NATION_LABEL[nationality],
    nationalIdMasked: `1${'*'.repeat(7)}${Math.floor(r(9) * 90 + 10)}`,
    mobileMasked: `+9665${'*'.repeat(5)}${Math.floor(r(10) * 900 + 100)}`,
    language: r(11) > 0.7 ? 'EN' : 'AR',
    region: regions[Math.floor(r(12) * regions.length)],
    client: client.name,
    clientId: client.id,
    product: products[i % products.length],
    amount,
    delinquencyDays: days,
    lastPayment: new Date(Date.now() - days * 86400 * 1000).toISOString(),
    status,
    segment,
    scores: { priority, propensity, contactability, legalRisk },
    assignedAgent: agent.id,
    assignedAgentName: agent.name,
    nextBestAction: r(13) > 0.5 ? 'Call 18:00–20:00, then WhatsApp payment-plan link' : 'WhatsApp link first, escalate to call if not opened in 24h',
    contactPref: r(14) > 0.5 ? 'WhatsApp then Call' : 'Call then SMS',
    consent: { call: true, whatsapp: !optOutWa && r(15) > 0.05, sms: true, email: r(16) > 0.4 },
    contactStats: {
      call30d: callAttempts,
      whatsapp30d: waAttempts,
      sms30d: smsAttempts,
      email30d: Math.floor(r(22) * 5),
      lastContactDaysAgo: Math.floor(r(23) * 14) + 1,
    },
    holds: { dispute: disputeHold, hardship: hardshipHold, legal: legalHold },
    contactWindow: contactWindowBlocked
      ? { blocked: true, reason: 'Debtor prefers calls 17:00–20:00 KSA only — currently outside window' }
      : { blocked: false },
    slaDue: new Date(Date.now() + (1 + r(17) * 5) * 86400 * 1000).toISOString(),
    avatarColor: ['amber', 'emerald', 'indigo', 'rose', 'sky', 'violet'][i % 6],
  };
});

export const INTEGRATIONS = [
  { id: 'erp', name: 'Client ERP / Core Banking', vendor: 'Mock API', status: 'connected', latency: 184, lastEvent: '2 min ago', icon: 'database' },
  { id: 'telephony', name: 'Telephony / Contact Center', vendor: 'Genesys-like Mock', status: 'connected', latency: 92, lastEvent: 'just now', icon: 'phone' },
  { id: 'whatsapp', name: 'WhatsApp Business', vendor: 'Mock Cloud API', status: 'connected', latency: 248, lastEvent: '15 sec ago', icon: 'message-circle' },
  { id: 'sms', name: 'SMS Gateway', vendor: 'Unifonic-like Mock', status: 'connected', latency: 312, lastEvent: '1 min ago', icon: 'message-square' },
  { id: 'email', name: 'Email / Transactional', vendor: 'SES-like Mock', status: 'connected', latency: 410, lastEvent: '3 min ago', icon: 'mail' },
  { id: 'simah', name: 'SIMAH Credit Bureau', vendor: 'Mock Sandbox', status: 'connected', latency: 540, lastEvent: '12 min ago', icon: 'shield' },
  { id: 'nafath', name: 'Nafath Identity', vendor: 'Mock Sandbox', status: 'connected', latency: 280, lastEvent: '6 min ago', icon: 'fingerprint' },
  { id: 'sadad', name: 'SADAD / Payment Gateway', vendor: 'Mock Saudi Payments', status: 'degraded', latency: 980, lastEvent: '4 min ago', icon: 'credit-card' },
  { id: 'legal', name: 'Legal Package Export', vendor: 'Najiz/Tanfeeth-like Mock', status: 'connected', latency: 220, lastEvent: '18 min ago', icon: 'gavel' },
  { id: 'bi', name: 'BI / Data Warehouse', vendor: 'Snowflake-like Mock', status: 'connected', latency: 168, lastEvent: '5 min ago', icon: 'bar-chart-3' },
];

export const EVENT_LOG = Array.from({ length: 14 }).map((_, i) => {
  const evts = [
    { type: 'PaymentReceived', src: 'Alwasl Recovery OS', dst: 'Payment Gateway', status: 'success', payload: 'SAR 2,500 against bill SAD-775913' },
    { type: 'WhatsAppDelivered', src: 'Alwasl Recovery OS', dst: 'WhatsApp Cloud', status: 'success', payload: 'msg_id wamid.HBgL... delivered' },
    { type: 'NafathChallenge', src: 'Debtor Portal', dst: 'Nafath Mock', status: 'success', payload: 'code 47 confirmed' },
    { type: 'ERPImportBatch', src: 'Client ERP', dst: 'Alwasl Recovery OS', status: 'success', payload: '1,284 accounts received' },
    { type: 'SIMAHQuery', src: 'Alwasl Recovery OS', dst: 'SIMAH Sandbox', status: 'success', payload: 'risk indicator B2' },
    { type: 'CallEnded', src: 'Telephony', dst: 'Alwasl Recovery OS', status: 'success', payload: 'duration 3m 42s, disposition RPC' },
    { type: 'SADADBillCreated', src: 'Alwasl Recovery OS', dst: 'SADAD Mock', status: 'success', payload: 'bill SAD-775913 SAR 1,500' },
    { type: 'WhatsAppFailed', src: 'Alwasl Recovery OS', dst: 'WhatsApp Cloud', status: 'failed', payload: 'opt-out blocked at policy gate' },
    { type: 'LegalPackageGenerated', src: 'Alwasl Recovery OS', dst: 'Legal Export Mock', status: 'success', payload: 'CASE-10428 package v1' },
    { type: 'PolicyBlock', src: 'Compliance Engine', dst: 'Outreach Service', status: 'blocked', payload: 'contact window 22:30 outside policy' },
  ];
  const e = evts[i % evts.length];
  return {
    eventId: `EVT-2026-${(2000 + i).toString().padStart(6, '0')}`,
    timestamp: new Date(Date.now() - i * 7 * 60 * 1000).toISOString(),
    latencyMs: 120 + Math.round(seedRand(i) * 700),
    correlationId: `CORR-${8800 + i}-${(i * 7) % 100}`,
    ...e,
  };
});

export const MANAGER_KPIS = [
  { id: 'assigned', label: 'Total Assigned Debt', value: 86761300, format: 'sar', trend: +4.2, hint: 'across 6 active portfolios' },
  { id: 'recovered', label: 'Recovered (MTD)', value: 18420600, format: 'sar', trend: +12.6, hint: 'vs. last month' },
  { id: 'recRate', label: 'Recovery Rate', value: 21.2, format: 'pct', trend: +1.4, hint: 'CEI proxy' },
  { id: 'active', label: 'Active Debtors', value: 6342, format: 'num', trend: -2.1, hint: '−138 vs. last week' },
  { id: 'ptpToday', label: 'Promises Due Today', value: 184, format: 'num', trend: +6, hint: 'SAR 1.2M expected' },
  { id: 'channelConv', label: 'WhatsApp Conversion', value: 38.6, format: 'pct', trend: +5.8, hint: 'vs. SMS 14.2%' },
  { id: 'compliance', label: 'Compliance Alerts', value: 7, format: 'num', trend: -3, hint: '5 resolved today' },
  { id: 'legal', label: 'Legal Pipeline', value: 412, format: 'num', trend: +1.2, hint: 'SAR 38.4M exposure' },
];

export const RECOVERY_TREND = [
  { m: 'Jan', recovered: 9.2, assigned: 18.1 },
  { m: 'Feb', recovered: 10.4, assigned: 19.3 },
  { m: 'Mar', recovered: 12.1, assigned: 22.4 },
  { m: 'Apr', recovered: 13.6, assigned: 21.8 },
  { m: 'May', recovered: 15.2, assigned: 24.6 },
  { m: 'Jun', recovered: 18.4, assigned: 26.1 },
];

export const CHANNEL_PERFORMANCE = [
  { channel: 'WhatsApp', sent: 4820, delivered: 4612, read: 3984, replied: 1860, converted: 1242 },
  { channel: 'Voice Call', sent: 2240, delivered: 1986, read: 1986, replied: 1410, converted: 980 },
  { channel: 'SMS', sent: 6120, delivered: 5840, read: 3120, replied: 612, converted: 488 },
  { channel: 'Email', sent: 3210, delivered: 3104, read: 1480, replied: 244, converted: 132 },
];

export const PORTFOLIO_MIX = [
  { name: 'Retail Bank', value: 42 },
  { name: 'Auto Finance', value: 22 },
  { name: 'Mortgage', value: 18 },
  { name: 'BNPL', value: 10 },
  { name: 'Telecom', value: 8 },
];

export const COMPLIANCE_RULES = [
  { id: 'window', label: 'Contact window', value: '09:00 – 21:00 (KSA)', enabled: true },
  { id: 'attempts', label: 'Max attempts / day', value: '3 attempts', enabled: true },
  { id: 'optout', label: 'Block on opt-out', value: 'Strict block', enabled: true },
  { id: 'dispute', label: 'Dispute hold', value: 'Block all contact', enabled: true },
  { id: 'language', label: 'Language matching', value: 'Prefer debtor language', enabled: true },
  { id: 'recording', label: 'Call recording', value: 'Always-on, encrypted', enabled: true },
];

export const LEGAL_CASES = DEBTORS.filter((d) => d.amount > 18000 && d.delinquencyDays > 120).slice(0, 8).map((d, i) => ({
  ...d,
  legalReadiness: 60 + Math.round(seedRand(i + 99) * 38),
  docsMissing: i % 3 === 0 ? ['Client authorization', 'Statement of account'] : i % 3 === 1 ? ['Power of attorney'] : [],
  legalStatus: ['Pre-Legal Review', 'Documents Pending', 'Approved for Filing', 'Filed — Court'][i % 4],
}));

export const REASON_CODES = {
  HIGH_VALUE_CASE: 'Outstanding above SAR 15,000',
  AGENT_HAS_CAPACITY: 'Agent below 90% workload',
  ARABIC_LANGUAGE_MATCH: 'Debtor language matched',
  RIYADH_BRANCH_MATCH: 'Branch alignment with debtor region',
  PAYMENT_PROPENSITY_HIGH: 'Propensity score ≥ 70',
  PTP_DUE_TODAY: 'Promise-to-pay due today',
  LEGAL_RISK_LOW: 'Legal risk score ≤ 40',
  CLIENT_PRIORITY_A: 'Client tier A',
};
